import { FC, SyntheticEvent, useEffect, useState } from "react";
import SectionHeader from "../Layout/SectionHeader";

import classes from "./Battles.module.css";
import TabPanel from "@mui/material/Tabs";
import { Badge, Tab, Tabs } from "@mui/material";
import PendingBattle from "./PendingBattle";
import OngoingBattle from "./OngoingBattle";
import FinishedBattle from "./FinishedBattle";
import { userState } from "../../store/user";
import { useSelector } from "react-redux";
import axios from "axios";
import { BattleModelDocument } from "../image/Image";
import { TopicModelDocument } from "../battle/StartBattle";

interface Props {
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const Battles: FC<Props> = ({ setPopupImage }) => {
  const [value, setValue] = useState("pending");
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [showTopics, setShowTopics] = useState(false);
  const [topics, setTopics] = useState<TopicModelDocument[] | []>([]);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [serverTime, setServerTime] = useState(Date.now());
  const [pendingBattles, setPendingBattles] = useState<BattleModelDocument[]>(
    []
  );
  const [ongoingBattles, setOngoingBattles] = useState<BattleModelDocument[]>(
    []
  );
  const [finishedBattles, setFinishedBattles] = useState<BattleModelDocument[]>(
    []
  );
  const handleTabChange = (
    e: SyntheticEvent<Element, Event>,
    tabIndex: any
  ) => {
    window.scrollTo({
      top: 31,
      behavior: "smooth",
    });
    setValue(tabIndex);
  };
  const getUserBattles = async () => {
    setScreenIsLoading(true);
    await axios
      .get(`${API_URL}/battles`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        setServerTime(response.data.serverTime);
        setPendingBattles(response.data.pendingBattles);
        setOngoingBattles(response.data.ongoingBattles);
        setFinishedBattles(response.data.finishedBattles);
        setTopics(response.data.topics);
        setScreenIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setScreenIsLoading(false);
      });
  };
  useEffect(() => {
    console.log("battles use effect");
    const getUserBattles = async () => {
      await axios
        .get(`${API_URL}/battles`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setServerTime(response.data.serverTime);
          setPendingBattles(response.data.pendingBattles);
          setOngoingBattles(response.data.ongoingBattles);
          setFinishedBattles(response.data.finishedBattles);
          setTopics(response.data.topics);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    getUserBattles();
  }, []);
  return (
    <>
      <SectionHeader label="Battles" />
      {!screenIsLoading && (
        <section className={classes.battles}>
          <div className={classes.topics}>
            <div
              className={`${classes.topicsHeader} ${
                showTopics ? classes.open : ""
              }`}
              onClick={() => {
                setShowTopics((prevState) => !prevState);
              }}
            >
              <h2>
                QUIZZES{" "}
                <span className={classes.topicsBadge}>{topics.length}</span>
              </h2>
              <svg
                width="9"
                height="4"
                viewBox="0 0 9 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0H9L4.5 4L0 0Z" fill="#19a7e7" />
              </svg>
            </div>
            <div className={classes.topicsListWrapper}>
              <div>
                <div
                  className={`${classes.topicsList} ${
                    showTopics ? classes.expanded : ""
                  }`}
                >
                  {topics.map((topic) => (
                    <div
                      key={`topic-${topic._id}`}
                      className={`${classes.topic} ${
                        topic.status === "announced" ? classes.disabled : ""
                      }`}
                    >
                      <label>
                        <b>{topic.title}</b>
                        <span className={classes.question}>
                          {topic.question}
                        </span>
                        <div className={classes.tags}>
                          {topic.andTags?.map((tag) => (
                            <div
                              key={`tag-${tag}`}
                              className={`${classes.tag} ${classes.important}`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 15"
                                fill="none"
                              >
                                <path
                                  d="M3.14697 8.20187L5.80826 10.5882L12.8529 4.41177"
                                  stroke="#868686"
                                  strokeWidth="1.11111"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              {tag}
                            </div>
                          ))}
                          {topic.orTags?.map((tag) => (
                            <div key={`tag-${tag}`} className={classes.tag}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 15"
                                fill="none"
                              >
                                <path
                                  d="M3.14697 8.20187L5.80826 10.5882L12.8529 4.41177"
                                  stroke="#868686"
                                  strokeWidth="1.11111"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              {tag}
                            </div>
                          ))}
                        </div>
                        {topic.status !== "active" && (
                          <span className={classes.status}>{topic.status}</span>
                        )}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Tabs
            variant="fullWidth"
            value={value}
            onChange={handleTabChange}
            className={classes.tabs}
          >
            <Tab
              value="pending"
              label={
                <Badge
                  badgeContent={
                    pendingBattles.length === 0 ? "0" : pendingBattles.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  Pending
                </Badge>
              }
            />
            <Tab
              value="ongoing"
              label={
                <Badge
                  badgeContent={
                    ongoingBattles.length === 0 ? "0" : ongoingBattles.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  Ongoing
                </Badge>
              }
            />
            <Tab
              value="finished"
              label={
                <Badge
                  badgeContent={
                    finishedBattles.length === 0 ? "0" : finishedBattles.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  Finished
                </Badge>
              }
            />
          </Tabs>
          {value === "pending" && (
            <TabPanel value="pending">
              <div className="container">
                {pendingBattles.length > 0 && (
                  <div className={classes.list}>
                    {pendingBattles.map((battle) => (
                      <PendingBattle
                        key={battle._id}
                        battleID={battle._id}
                        serverTime={serverTime}
                        artworkID={battle.artwork1ID}
                        artworkSrc={battle.artwork1Src}
                        createdAt={battle.createdAt}
                        level={battle.level}
                        nextLevelBattle={battle.nextLevelBattleForUser1}
                        topic={battle.topic}
                      />
                    ))}
                  </div>
                )}
                {pendingBattles.length === 0 && (
                  <div className={classes.empty}>
                    You don't have pending battles
                  </div>
                )}
              </div>
            </TabPanel>
          )}
          {value === "ongoing" && (
            <TabPanel value="ongoing">
              <div className="container">
                {ongoingBattles.length > 0 && (
                  <div className={classes.list}>
                    {ongoingBattles.map((battle) => (
                      <OngoingBattle
                        setPopupImage={setPopupImage}
                        key={battle._id}
                        currentUserIndex={battle.user1ID === user._id ? 0 : 1}
                        {...battle}
                      />
                    ))}
                  </div>
                )}
                {ongoingBattles.length === 0 && (
                  <div className={classes.empty}>
                    You don't have ongoing battles
                  </div>
                )}
              </div>
            </TabPanel>
          )}
          {value === "finished" && (
            <TabPanel value="finished">
              <div className="container">
                {finishedBattles.length > 0 && (
                  <div className={classes.list}>
                    {finishedBattles.map((battle) => (
                      <FinishedBattle
                        setPopupImage={setPopupImage}
                        key={battle._id}
                        currentUserIndex={battle.user1ID === user._id ? 0 : 1}
                        refreshUserBattles={getUserBattles}
                        {...battle}
                      />
                    ))}
                  </div>
                )}
                {finishedBattles.length === 0 && (
                  <div className={classes.empty}>
                    You don't have finished battles
                  </div>
                )}
              </div>
            </TabPanel>
          )}
        </section>
      )}
    </>
  );
};

export default Battles;
